export const GET_APPROVAL = 'GET_APPROVAL'
export const GET_APPROVALS = 'GET_APPROVALS'
export const UPDATE_APPROVALS = 'UPDATE_APPROVALS'
export const GET_ALL_APPROVALS = 'GET_ALL_APPROVALS'
